<script>
    let className='';
    export {className as class};
    export let color = 'currentColor';
    export let icon;
    export let size=22;
    export let title='';
</script>

<img on:click class={className} src="https://icongr.am/material/{icon}.svg?size={size}&color={color}" alt={title} {title}>